// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/accounts_service.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateAccountRequestSchema, CreateAccountResponseSchema } from "./create_account_pb";
import { file_accounts_create_account } from "./create_account_pb";
import type { DeleteMyAccountRequestSchema, DeleteMyAccountResponseSchema } from "./delete_my_account_pb";
import { file_accounts_delete_my_account } from "./delete_my_account_pb";
import type { CancelMyAccountDeletionRequestSchema, CancelMyAccountDeletionResponseSchema } from "./cancel_my_account_deletion_pb";
import { file_accounts_cancel_my_account_deletion } from "./cancel_my_account_deletion_pb";
import type { UpdateMyAccountRequestSchema, UpdateMyAccountResponseSchema } from "./update_my_account_pb";
import { file_accounts_update_my_account } from "./update_my_account_pb";
import type { VerifyEmailRequestSchema, VerifyEmailResponseSchema } from "./verify_email_pb";
import { file_accounts_verify_email } from "./verify_email_pb";
import type { GetMyAccountRequestSchema, GetMyAccountResponseSchema } from "./get_my_account_pb";
import { file_accounts_get_my_account } from "./get_my_account_pb";
import type { GetAccountRequestSchema, GetAccountResponseSchema } from "./get_account_pb";
import { file_accounts_get_account } from "./get_account_pb";
import type { GetPartialAccountRequestSchema, GetPartialAccountResponseSchema } from "./get_partial_account_pb";
import { file_accounts_get_partial_account } from "./get_partial_account_pb";
import type { SearchAccountsRequestSchema, SearchAccountsResponseSchema } from "./search_accounts_pb";
import { file_accounts_search_accounts } from "./search_accounts_pb";
import type { SearchAccountsFullRequestSchema, SearchAccountsFullResponseSchema } from "./search_accounts_full_pb";
import { file_accounts_search_accounts_full } from "./search_accounts_full_pb";
import type { ReportAccountRequestSchema, ReportAccountResponseSchema } from "./report_account_pb";
import { file_accounts_report_account } from "./report_account_pb";
import type { BlockAccountRequestSchema, BlockAccountResponseSchema } from "./block_account_pb";
import { file_accounts_block_account } from "./block_account_pb";
import type { UnblockAccountRequestSchema, UnblockAccountResponseSchema } from "./unblock_account_pb";
import { file_accounts_unblock_account } from "./unblock_account_pb";
import type { ListMyBlockedAccountsRequestSchema, ListMyBlockedAccountsResponseSchema } from "./list_my_blocked_accounts_pb";
import { file_accounts_list_my_blocked_accounts } from "./list_my_blocked_accounts_pb";
import type { UpdateMySettingsRequestSchema, UpdateMySettingsResponseSchema } from "./update_my_settings_pb";
import { file_accounts_update_my_settings } from "./update_my_settings_pb";
import type { UpdateMyJobAlertsRequestSchema, UpdateMyJobAlertsResponseSchema } from "./update_my_job_alerts_pb";
import { file_accounts_update_my_job_alerts } from "./update_my_job_alerts_pb";

/**
 * Describes the file accounts/accounts_service.proto.
 */
export const file_accounts_accounts_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_accounts_create_account, file_accounts_delete_my_account, file_accounts_cancel_my_account_deletion, file_accounts_update_my_account, file_accounts_verify_email, file_accounts_get_my_account, file_accounts_get_account, file_accounts_get_partial_account, file_accounts_search_accounts, file_accounts_search_accounts_full, file_accounts_report_account, file_accounts_block_account, file_accounts_unblock_account, file_accounts_list_my_blocked_accounts, file_accounts_update_my_settings, file_accounts_update_my_job_alerts]);

/**
 * @generated from service protos.accounts.Accounts
 */
export const Accounts: GenService<{
  /**
   * @generated from rpc protos.accounts.Accounts.CreateAccount
   */
  createAccount: {
    methodKind: "unary";
    input: typeof CreateAccountRequestSchema;
    output: typeof CreateAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.DeleteMyAccount
   */
  deleteMyAccount: {
    methodKind: "unary";
    input: typeof DeleteMyAccountRequestSchema;
    output: typeof DeleteMyAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.CancelMyAccountDeletion
   */
  cancelMyAccountDeletion: {
    methodKind: "unary";
    input: typeof CancelMyAccountDeletionRequestSchema;
    output: typeof CancelMyAccountDeletionResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.UpdateMyAccount
   */
  updateMyAccount: {
    methodKind: "unary";
    input: typeof UpdateMyAccountRequestSchema;
    output: typeof UpdateMyAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.GetMyAccount
   */
  getMyAccount: {
    methodKind: "unary";
    input: typeof GetMyAccountRequestSchema;
    output: typeof GetMyAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof GetAccountRequestSchema;
    output: typeof GetAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.GetPartialAccount
   */
  getPartialAccount: {
    methodKind: "unary";
    input: typeof GetPartialAccountRequestSchema;
    output: typeof GetPartialAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.VerifyEmail
   */
  verifyEmail: {
    methodKind: "unary";
    input: typeof VerifyEmailRequestSchema;
    output: typeof VerifyEmailResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.SearchAccounts
   */
  searchAccounts: {
    methodKind: "unary";
    input: typeof SearchAccountsRequestSchema;
    output: typeof SearchAccountsResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.SearchAccountsFull
   */
  searchAccountsFull: {
    methodKind: "unary";
    input: typeof SearchAccountsFullRequestSchema;
    output: typeof SearchAccountsFullResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.ReportAccount
   */
  reportAccount: {
    methodKind: "unary";
    input: typeof ReportAccountRequestSchema;
    output: typeof ReportAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.BlockAccount
   */
  blockAccount: {
    methodKind: "unary";
    input: typeof BlockAccountRequestSchema;
    output: typeof BlockAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.UnblockAccount
   */
  unblockAccount: {
    methodKind: "unary";
    input: typeof UnblockAccountRequestSchema;
    output: typeof UnblockAccountResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.ListMyBlockedAccounts
   */
  listMyBlockedAccounts: {
    methodKind: "unary";
    input: typeof ListMyBlockedAccountsRequestSchema;
    output: typeof ListMyBlockedAccountsResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.UpdateMySettings
   */
  updateMySettings: {
    methodKind: "unary";
    input: typeof UpdateMySettingsRequestSchema;
    output: typeof UpdateMySettingsResponseSchema;
  },
  /**
   * @generated from rpc protos.accounts.Accounts.UpdateMyJobAlerts
   */
  updateMyJobAlerts: {
    methodKind: "unary";
    input: typeof UpdateMyJobAlertsRequestSchema;
    output: typeof UpdateMyJobAlertsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_accounts_accounts_service, 0);

